import { defineComponent, watch, computed, reactive, watchEffect, toRefs } from '@vue/composition-api';
import { immediateSendLog, radarLog, sendLog } from '@common/log';
import { getOnelink } from '@common/util';
import { defaultOneLink } from '@common/const';
import Popup from 'vant/lib/popup';
// import Vue from 'vue';
import './popup.css';

// if (window.__INITIAL_STATE__) {
//     const { Popup } = require('vant');
//     Vue.use(Popup);
// }

export default defineComponent({
    components: {
        vanPopup: Popup,
    },
    props: {
        show: {
            type: Boolean,
            default: false,
        },
    },
    emits: ['closePopupDownload', 'directDownLoadCallBack'],
    setup(props, { root, emit }: any) {
        const {
            initData: { kpn },
            message: { localLang, kpn: initKpn = {}, onelink: onelinkMap = {}, pageConf },
        } = root.$store.state;

        const oneLinkUrl = onelinkMap[kpn] || defaultOneLink;

        let logoText = 'Kwai';
        let logoUrl = 'kwai';
        let app = 'KWAI';
        switch (kpn) {
            case initKpn['kwai.me'] || 'KWAI.ME':
                logoUrl = 'me';
                app = 'KWAI_ME';
                break;
            case initKpn.snack || 'KWAI_BULLDOG':
                logoText = 'SnackVideo';
                logoUrl = 'snack';
                app = 'KWAI_BULLDOG';
                break;
            default:
                logoUrl = 'kwai';
        }

        const state = reactive({
            isShowDownloadAPK: props.show,
        });

        watchEffect(() => {
            state.isShowDownloadAPK = props.show;
            if (props.show) {
                sendLog({
                    type: 'show',
                    name: 'APK_INSTALL_POPUP',
                    value: { app },
                });
            }
        });

        const sendAPKLog: Function = (button_name: string) => {
            /**
              * button_name: //枚举型,按钮名称
                MAIN_INSTALL //直接下载
                CLOSE_BLANK //点空白关闭
                SUB_INSTALL //gp下载
                CLOSE_BUTTON //点叉关闭 */
            immediateSendLog({
                type: 'click',
                name: 'APK_INSTALL_POPUP',
                value: {
                    app,
                    button_name,
                },
            });
            radarLog({
                name: 'SHARE_PHOTO_CLICK_COUNT',
                event_type: 'click',
                category: 'KWAI_SHARE',
                message: `点击${button_name}的次数`,
                src: window.location.pathname,
            });
        };

        const closeDialog: Function = (button_name: string) => {
            sendAPKLog(button_name);
            emit('closePopupDownload');
            const onelink = getOnelink(oneLinkUrl, 'sideloading');
            window.open(onelink);
        };

        const downAPK: Function = () => {
            state.isShowDownloadAPK = false;
            sendAPKLog('MAIN_INSTALL');
            emit('directDownLoadCallBack', true);
        };

        const openGP: Function = () => {
            sendAPKLog('SUB_INSTALL');
            const onelink = getOnelink(oneLinkUrl, 'sideloading');
            window.open(onelink);
        };

        const sendLinkLog: Function = (type: 'PRIVACY_AGREEMENT' | 'SERVICE_AGREEMENT') => {
            immediateSendLog({
                type: 'click',
                name: 'APK_INSTALL_POPUP',
                value: {
                    app,
                    button_name: type,
                },
            });
            radarLog({
                name: 'SHARE_PHOTO_CLICK_COUNT',
                event_type: 'click',
                category: 'KWAI_SHARE',
                message: '点击法务链接',
                src: window.location.pathname,
            });
        };
        
        return {
            ...toRefs(state),
            localLang,
            conf: pageConf.sideloading || {},
            app,
            logoText,
            logoUrl,
            downAPK,
            openGP,
            closeDialog,
            sendLinkLog,
        };
    },
});
